import { ExpertiseArea } from "./expertise.dictionary";


export class UserExperienceEntry {
    Email: string;
    ExperienceJson: string;
    constructor() { }
}

export class UserExperience {

    static ExpertiseAreas: ExpertiseArea[] = undefined;
    static textfields: string[] = []; // Free Text
    static switches: string[] = ["ResearchAreas", "VirusFamilies", "VaccinePlatforms", "AntibodyPlatforms", "AnimalModels", "ProjectManagement", "QualityRegulatory", "HumanStudies"];
    
    ResearchAreas: string[];
    VirusFamilies: string[];
    VaccinePlatforms: string[];
    AntibodyPlatforms: string[];
    AnimalModels: string[];
    ProjectManagement: string[];
    QualityRegulatory: string[];
    HumanStudies: string[];



    constructor() { }

    initialize(): void {

        $("#expertise-form :input").each((index, element) => {
            let input: any = $(element);
            let inputId: string = input.attr("id");
            //console.log(input.attr("id"), input.is(":checked"));

            if (input.is(":checked")) {

                if (inputId.startsWith("research")) {
                    if (!this.ResearchAreas) this.ResearchAreas = [];
                    this.ResearchAreas.push(inputId);
                }
                else if (inputId.startsWith("virus")) {
                    if (!this.VirusFamilies) this.VirusFamilies = [];
                    this.VirusFamilies.push(inputId);
                }
                else if (inputId.startsWith("vaccine")) {
                    if (!this.VaccinePlatforms) this.VaccinePlatforms = [];
                    this.VaccinePlatforms.push(inputId);
                }
                else if (inputId.startsWith("antibody")) {
                    if (!this.AntibodyPlatforms) this.AntibodyPlatforms = [];
                    this.AntibodyPlatforms.push(inputId);
                }
                else if (inputId.startsWith("animalmodel")) {
                    if (!this.AnimalModels) this.AnimalModels = [];
                    this.AnimalModels.push(inputId);
                }
                else if (inputId.startsWith("management")) {
                    if (!this.ProjectManagement) this.ProjectManagement = [];
                    this.ProjectManagement.push(inputId);
                }
                else if (inputId.startsWith("quality")) {
                    if (!this.QualityRegulatory) this.QualityRegulatory = [];
                    this.QualityRegulatory.push(inputId);
                }
                else if (inputId.startsWith("humantrial")) {
                    if (!this.HumanStudies) this.HumanStudies = [];
                    this.HumanStudies.push(inputId);
                }
            }
        });
    }

    setupUI(): void {
        let nameMap: Map<string, string> = new Map<string, string>();
        nameMap.set("ResearchAreas", "research");
        nameMap.set("VirusFamilies", "virus");
        nameMap.set("VaccinePlatforms", "vaccine");
        nameMap.set("AntibodyPlatforms", "antibody");
        nameMap.set("AnimalModels", "animalmodel");
        nameMap.set("ProjectManagement", "management");
        nameMap.set("QualityRegulatory", "quality");
        nameMap.set("HumanStudies", "humantrial");

        UserExperience.textfields.forEach((field: string) => {
            // For Free Text
        });
        
        UserExperience.switches.forEach((field: string) => {
            if (this[field] != undefined) {
                let foundString = nameMap.get(field);
                if (foundString) {
                    let categoryId = `#select-${foundString}`;
                    $(categoryId).selectpicker("val", "Yes").trigger("change");
                }

                this[field].forEach((switchId: string) => {
                    $("#" + switchId).prop("checked", true);
                });
            }
        });
    }

    getExpertiseStringForField(field: string): string {
        let output: string = "";

        if (this[field] == undefined && this[field] == undefined) return "";
        else if (this[field] != undefined) {

            if (UserExperience.ExpertiseAreas == undefined) { UserExperience.ExpertiseAreas = ExpertiseArea.GetExpertiseAreas(); }

            UserExperience.ExpertiseAreas.forEach((area: ExpertiseArea) => {
                if (this[field].includes(area.id)) {
                    if (!area.id.startsWith("text")) {
                        output = this.addValue(output, "<span class='nowrap'>" + area.value + "</span>");
                    }
                }

            });
        }

        if (this[field + "Other"] != undefined) {
            // For Free-text
        }

        return output;
    }

    addValue(output: string, value: string): string {
        if (output.length > 0) { output += ", "; }
        output += value;
        return output;
    }

    getHiddenFilter(): string {
        let output: string = "";
        UserExperience.switches.forEach((s: string) => {
            output += this.getExpertiseStringForField(s) + " ";
        });
        UserExperience.textfields.forEach((t: string) => {
            if (this[t] != undefined) { output += this[t] + " "; }
        });

        return output;
    }

    checkOtherEntries(): void {
        // For Free Text
    }
}
